var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#ececec"}},[_c('a-spin',{attrs:{"tip":_vm.title,"spinning":_vm.loading}},[_c('a-card',{attrs:{"headStyle":_vm.headStyle}},[_c('Filters',{attrs:{"component":'dashboard',"isActive":true},on:{"showLoader":_vm.showLoader}}),_c('div',{staticClass:"mt-2"},[_c('ProjectTable',{attrs:{"propData":{
            title: 'Project List',
            columns: _vm.columns,
            tableId: 'dashboardProjectTable',
            isActive: true,
            url: _vm.url
          }},on:{"showLoader":_vm.showLoader}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }